// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vhnP","label":"styles_label__3n7uQ"};